import React from "react";
//import variables from "../../styles/base/_universal.scss"

const buttonStyle = (minWidth, marginLeft, disabled) => ({
  //backgroundColor: disabled ? '#e6e7e8' : variables.themeColor,
  //color: disabled ? variables.disabledColor : 'white',
  fontWeight: 'bold',
  padding: '0px 13px',
  minWidth: minWidth ? `${minWidth}px` : 'auto',
  marginLeft: marginLeft ? `${marginLeft}px` : '0',
  borderRadius: '20px',
  height: '32px',
  textAlign: 'center',
  //fontSize: variables.fontSmallV2,
  cursor: disabled ? 'default' : 'pointer',
  outline: 'none',
  border: 'none',
  boxShadow: 'none',
  display: 'flex',
  alignItems: 'center',
});

const iconStyle = {
  paddingBottom: '2px',
};

const PrimaryButton = ({
  title,
  icon,
  handleClick,
  disabled,
  minWidth,
  marginLeft,
  customClass,
  fontSize,
}) => {
  return (
    <button
      style={buttonStyle(minWidth, marginLeft, disabled)}
      onClick={handleClick}
      disabled={disabled}
      className={customClass}
    >
      {icon && <img src={icon} alt="" style={iconStyle} />} {title}
    </button>
  );
};

export default PrimaryButton;
